export const GET_OPERATION_DATA = 'GET_OPERATION_DATA';
export const GET_OPERATION_DATA_ERROR = 'GET_OPERATION_DATA_ERROR';
export const SET_OPERATION_DATA = 'SET_OPERATION_DATA';
export const SET_ORDERS_VISIBILITY = 'SET_ORDERS_VISIBILITY';
export const SET_BICYCLES_VISIBILITY = 'SET_BICYCLES_VISIBILITY';
export const SET_MOTORCYCLES_VISIBILITY = 'SET_MOTORCYCLES_VISIBILITY';
export const SET_CARS_VISIBILITY = 'SET_CARS_VISIBILITY';
export const SET_WALKING_VISIBILITY = 'SET_WALKING_VISIBILITY';
export const TOGGLE_OPERATION = 'TOGGLE_OPERATION';
export const TOGGLE_OPERATION_AUTOREFRESH = 'TOGGLE_OPERATION_AUTOREFRESH';
export const SET_OPERATION_TAB = 'SET_OPERATION_TAB';
export const SET_COURIERS_VISIBILITY = 'SET_COURIERS_VISIBILITY';
